import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export type AlternativeProductDTO = {
  stockAmount: number;
  code: string;
  designation: string;
  sapMaterialNumber: string;
  url: string;
};

export type AlternativeProducts = {
  alternativeProducts: AlternativeProductDTO[];
};

type AlternativeProductsResponseDTO = {
  alternativeProducts?: AlternativeProductDTO[];
};

export async function fetchAlternativeProducts(productCode: string): Promise<AlternativeProducts> {
  const apiUrl = occUrl(`/products/${encodeURIComponent(productCode)}/alternatives`);

  const response = await occFetch(apiUrl);
  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data = (await response.json()) as AlternativeProductsResponseDTO;
    return { alternativeProducts: data.alternativeProducts ?? [] };
  }
  throw new Error("Error fetching data");
}
